import React from 'react';
import styled from "styled-components";
import Icon from "@atoms/icon";
import {getFacilitiesPersian} from "@hooks/facilities";

function Facilities({property}) {

    const facilities = property.facilities;
    const items = getFacilitiesPersian(facilities);

    if (items.length) {
        return (
            <React.Fragment>
                <h2>تجهیزات و امکانات</h2>
                <div className="row">
                    {
                        items.map(([item_key, item], key) =>
                            <Item className="d-flex align-items-center mt-16 mt-lg-24 col-md-4" key={key}>
                                <img src={"/_img/icons/facilities/" + item_key + '.svg'} alt=""/>
                                <Name>{item}</Name>
                            </Item>
                        )
                    }
                </div>
            </React.Fragment>
        )
    } else {
        return null;
    }
}

export default React.memo(Facilities);

//styles
const Icons = styled(Icon)`
    width: 24px;
    max-width: 24px;
`;

const Name = styled.span`
    margin-right: 16px;
`;

const Item = styled.div`

      img {
            width: 20px;
            height: 20px;
      }
       
    @media (max-width: ${props => props.theme.screenXsMax}) {
       //flex-direction: row-reverse;
       img {
            //margin-right: auto;
            margin-left: 24px;
       }
       ${Name} {
            margin-right: 0;
            
       }
    }
`;